import { create } from 'zustand';
import type { GroupBy, SortBy } from '@/features/tasks/grouping';

interface FilterState {
  search: string;
  assigneeId: number | null;
  /** Namespaced: 'ct:<id>' (content tag) or 'st:<id>' (standard tag) — the two
   *  Odoo models have COLLIDING numeric ids (38/38 on live data). */
  tagId: string | null;
  /** Focus one column ("If I want to just click on published how do I just
   *  see those?" — Allyson, 8/10). Set by clicking a column header or the
   *  filter bar's Stage picker; null = the whole board. */
  stageId: number | null;
  showCompleted: boolean;
  onlyUnassigned: boolean;
  dueThisWeek: boolean;
  groupBy: GroupBy;
  sortBy: SortBy;
  setSearch: (s: string) => void;
  setAssignee: (id: number | null) => void;
  setTag: (id: string | null) => void;
  setStage: (id: number | null) => void;
  setShowCompleted: (v: boolean) => void;
  setOnlyUnassigned: (v: boolean) => void;
  setDueThisWeek: (v: boolean) => void;
  setGroupBy: (g: GroupBy) => void;
  setSortBy: (s: SortBy) => void;
  reset: () => void;
}

const DEFAULTS = {
  search: '',
  assigneeId: null as number | null,
  tagId: null as string | null,
  stageId: null as number | null,
  showCompleted: false,
  onlyUnassigned: false,
  dueThisWeek: false,
  groupBy: 'stage' as GroupBy,
  sortBy: 'priority' as SortBy,
};

export const useFilterStore = create<FilterState>()((set) => ({
  ...DEFAULTS,
  setSearch: (search) => set({ search }),
  setAssignee: (assigneeId) => set({ assigneeId, onlyUnassigned: false }),
  setTag: (tagId) => set({ tagId }),
  setStage: (stageId) => set({ stageId }),
  setShowCompleted: (showCompleted) => set({ showCompleted }),
  setOnlyUnassigned: (onlyUnassigned) => set({ onlyUnassigned, assigneeId: null }),
  setDueThisWeek: (dueThisWeek) => set({ dueThisWeek }),
  setGroupBy: (groupBy) => set({ groupBy }),
  setSortBy: (sortBy) => set({ sortBy }),
  // Keep group/sort across area switches (a per-team preference); clear the rest.
  reset: () => set({ search: '', assigneeId: null, tagId: null, stageId: null, showCompleted: false, onlyUnassigned: false, dueThisWeek: false }),
}));
